module.exports = __webpack_public_path__ + "static/media/popup-password.713d9fa6.png";